import React from 'react';
import PropTypes from 'prop-types';

import style from './index.module.scss';

function SectionHeader({ headingLeft, headingRight, colWidth }) {
  return (
    <div className={`row ${style['row--header']}`}>
      <p className={`col-${colWidth} ${style['col--left']}`}>{headingLeft}</p>
      {headingRight && (
        <p className={`col-${12 - colWidth} ${style['col--right']}`}>
          {headingRight}
        </p>
      )}
    </div>
  );
}

SectionHeader.propTypes = {
  headingLeft: PropTypes.string.isRequired,
  headingRight: PropTypes.string,
  colWidth: PropTypes.number,
};

export default SectionHeader;
